import { useEffect } from 'react'
import classes from './Header.module.css'
import { ReactComponent as XSvg } from '../../../assets/NewX.svg';
import { ReactComponent as DragSvg } from '../../../assets/NewMove.svg';
import { ReactComponent as SidebarToggleIcon } from '../../../assets/SidebarToggle.svg';
import { ReactComponent as OpenWide } from '../../../assets/NewArrowSquareOut.svg';
import { ReactComponent as PortalBackChevron } from '../../../assets/PortalBackChevron.svg';
import { useDispatch, useSelector } from 'react-redux';
import { toggle } from '../sidebar/sidebarSlice'
import { useBotConfig } from '../../../context/BotConfigContext';
import { normalizeBadgeFields } from '../../admin/badgeIcon';
import sidebarHeaderClasses from '../sidebar/SidebarHeader/SidebarHeader.module.css'

function Header() {
  const config = useBotConfig();
  const showHeaderIcons = config?.showHeaderIcons === true;
  const isPortalMobile = config?.isPortalMobile === true;
  const isMobile = useSelector(state => state.layout).isMobile
  const dispatch = useDispatch()
  const sidebarState = useSelector(state => state.sidebar)
  const { texts } = useSelector(state => state.translate)

  useEffect(() => {
      if (!showHeaderIcons) return;

      function dragElement(elmnt) {
          var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
          elmnt.onmousedown = dragMouseDown;
          function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            pos3 = e.screenX;
            pos4 = e.screenY;
            document.onmouseup = closeDragElement;
            document.onmouseleave = closeDragElement;
            document.onmousemove = elementDrag;
          }

          function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            pos1 = pos3 - e.screenX;
            pos2 = pos4 - e.screenY;
            pos3 = e.screenX;
            pos4 = e.screenY;
            window.parent.postMessage("framelocation;"+pos1+";"+pos2,"*")
          }

          function closeDragElement() {
            document.onmouseleave = null
            document.onmouseup = null;
            document.onmousemove = null;
          }
      }
      dragElement(document.getElementById("dragHeader"))
  }, [showHeaderIcons])

  let onClick = () => {
      window.parent.postMessage("closeBot","*")
  }

  let wideHandler = () => {
      window.parent.postMessage("wide_window","*")
  }

  let chatsToggleHandler = () => {
    if (sidebarState.isOpen) {
      dispatch(toggle({isOpen: false}))
    } else {
      dispatch(toggle({isOpen: true}))
    }
  }

  const toggleIconClass = sidebarState.isOpen
    ? sidebarHeaderClasses.ToggleIconCollapsed
    : sidebarHeaderClasses.ToggleIconExpanded

  if (!showHeaderIcons) {
    const botName = config?.headerBotName;
    if (isPortalMobile) {
      return (
        <div className={`${classes.Header} ${classes.PortalMobileHeader}`}>
          <button
            type="button"
            className={classes.PortalMobileBack}
            onClick={() => config?.onOpenPortalBotList?.()}
            aria-label={texts.back}
          >
            <PortalBackChevron className={classes.PortalMobileBackIcon} aria-hidden="true" />
          </button>
          {botName ?
            <span className={classes.PortalMobileTitle}>{botName}</span>
            : null}
        </div>
      );
    }
    const description = config?.headerDescription;
    const { icon } = normalizeBadgeFields(config);
    return (
      <div className={`${classes.Header} ${classes.PortalHeader}`}>
        <div className={classes.PortalBotSection}>
          {icon ?
            <img
              src={icon}
              alt=""
              className={classes.BotTypeIcon}
            />
            : null}
          {botName ?
            <span className={classes.PortalBotTitle}>{botName}</span>
            : null}
          {description ?
            <span className={classes.PortalBotSubTitle}>{description}</span>
            : null}
        </div>
        <div className={classes.PortalSubjectSection}>
          {config?.subjectImageUrl ?
            <img src={config.subjectImageUrl} alt="" className={classes.PortalSubjectImage} />
            : null}
          {config?.subjectName ?
            <span className={classes.PortalSubjectName}>{config.subjectName}</span>
            : null}
        </div>
      </div>
    );
  }

  return (
      <div id="dragHeader" className={classes.Header}>
          {showHeaderIcons ?
            <>
              <div onClick={onClick} className={classes.CloseButton}>
                <XSvg/>
              </div>
              {!isMobile ?
                <div className={classes.DragButton}>
                  <DragSvg/>
                </div>
                :
                <div className={classes.ChatsContainer}>
                  <div className={classes.ChatsButton} onClick={chatsToggleHandler}>
                    <SidebarToggleIcon className={toggleIconClass} />
                  </div>
                </div>
              }
              {!isMobile ?
                <div onClick={wideHandler} className={classes.DragButton}>
                  <OpenWide/>
                </div>
                : null}
            </>
            : null}
      </div>
  );
}

export default Header;
